import { render } from "./SocialConnect.vue?vue&type=template&id=7cde4c82&scoped=true"
import script from "./SocialConnect.vue?vue&type=script&lang=js"
export * from "./SocialConnect.vue?vue&type=script&lang=js"

import "./SocialConnect.vue?vue&type=style&index=0&id=7cde4c82&scoped=true&lang=css"

import exportComponent from "/root/frontTioPizza/mymenucli/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7cde4c82"]])

export default __exports__